export type Pillar = {
  slug: string;
  path: string;
  eyebrow: string;
  title: string;
  italic: string;
  lead: string;
  metaTitle: string;
  metaDescription: string;
  heroImage: string;
  introImage: string;
};

export const PILLARS: Pillar[] = [
  {
    slug: "coaching-training",
    path: "/coaching-and-training",
    eyebrow: "Pillar 01",
    title: "Coaching",
    italic: "& Training",
    lead: "1-on-1 CEO-level coaching, administrative hiring consulting, and team recruitment - the foundation every KCN agent stands on.",
    metaTitle: "Real Estate Coaching for Agents | Kristan Cole Network",
    metaDescription:
      "Real estate coaching for agents at KCN: 1-on-1 accountability, sales training, and a real estate business plan for agents who want to build, not just close.",
    heroImage: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2000&q=80",
    introImage: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=2000&q=80",
  },
  {
    slug: "technology-tools",
    path: "/technology-and-tools",
    eyebrow: "Pillar 02",
    title: "Technology",
    italic: "& Tools",
    lead: "A vetted stack - Brivity CRM, Callfire, Google Suite, Zoom, plus the proprietary KCN Intranet and KCN Rewards App - and the training to actually use it.",
    metaTitle: "AI for Real Estate Agents - Tools and Tech | KCN",
    metaDescription:
      "AI for real estate agents, a done-for-you real estate agent website, and the KCN stack: Brivity CRM, automation, and workflows that make agents faster.",
    heroImage: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=2000&q=80",
    introImage: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=2000&q=80",
  },
  {
    slug: "growth-team-building",
    path: "/growth-and-team-building",
    eyebrow: "Pillar 03",
    title: "Growth",
    italic: "& Team Building",
    lead: "How solo agents become team leaders - and how existing teams scale without losing their culture or their calendar.",
    metaTitle: "Become a Real Estate Team Leader - Growth at KCN",
    metaDescription:
      "The path from producer to real estate team leader: hiring, org design, scorecards, and real estate agent expansion into new markets, coached by KCN.",
    heroImage: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=80",
    introImage: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=2000&q=80",
  },
  {
    slug: "marketing-strategy",
    path: "/marketing-content-and-strategy",
    eyebrow: "Pillar 04",
    title: "Marketing",
    italic: "Content & Strategy",
    lead: "Listing Alerts, Digital Graphics, Market Reports, Video Support - done-for-you creative and the strategy to turn it into appointments.",
    metaTitle: "Real Estate Agent SEO, Branding and Content | KCN",
    metaDescription:
      "Real estate agent SEO, real estate agent branding, and real estate blog content, done for you: listing alerts, market reports, and weekly articles.",
    heroImage: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=2000&q=80",
    introImage: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80",
  },
  {
    slug: "sales-leads-referrals",
    path: "/sales-leads-and-referrals",
    eyebrow: "Pillar 05",
    title: "Sales Leads",
    italic: "& Referrals",
    lead: "Brivity IDX, KWKLY Codes, ISA leverage, Facebook ads, and a national referral network - leads that match the playbook.",
    metaTitle: "Real Estate Referral Network and Lead Generation | KCN",
    metaDescription:
      "A national real estate referral network plus real estate agent lead generation: Brivity IDX, ISA leverage, vetted lead sources, and coached follow-up.",
    heroImage: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=2000&q=80",
    introImage: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=2000&q=80",
  },
  {
    slug: "administrative-support",
    path: "/administrative-support",
    eyebrow: "Pillar 06",
    title: "Administrative",
    italic: "Support",
    lead: "A virtual support team, database management, autoplan management, and marketing ops - so agents can focus on their One Thing.",
    metaTitle: "Real Estate Agent Transaction Coordinator and Admin | KCN",
    metaDescription:
      "A real estate agent transaction coordinator plus real estate agent admin support: contract-to-close, database management, and marketing ops, handled for you.",
    heroImage: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=80",
    introImage: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2000&q=80",
  },
];

export const PILLAR_BY_SLUG = Object.fromEntries(
  PILLARS.map((p) => [p.slug, p]),
) as Record<string, Pillar>;
